import React from "react";
import Pdp from "./pdp";
import reduxModules from "./redux/nextjs-modules";
import { fetchPdpState } from "./redux/reducers";

const PdpMaster = (props) => {
  return (
    <React.Fragment>
      <Pdp {...props} />
    </React.Fragment>
  );
};

PdpMaster.reduxModules = reduxModules;

PdpMaster.getInitialProps = async function (context) {
  const { itemCode } = context.query;
  await context.store.dispatch(fetchPdpState(itemCode));
};

export default PdpMaster;
